import {
  renameApprovalGroup as renameApprovalGroup,
  createApprovalGroup,
  toggleApprovalGroupAutoApproval,
  updateApprovalGroupDefaultGroupManager,
} from '@lib/api'
import { approvalGroupsKeys, adminApprovalGroupsKeys } from '@lib/keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useRenameApprovalGroup = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ id, name }: { id: number; name: string }) =>
      renameApprovalGroup(id, name),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(adminApprovalGroupsKeys.all)
        void queryClient.invalidateQueries(approvalGroupsKeys.all)
      },
    },
  )
}

export const useCreateApprovalGroup = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ name }: { name: string }) => createApprovalGroup(name),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(adminApprovalGroupsKeys.all)
        void queryClient.invalidateQueries(approvalGroupsKeys.all)
      },
    },
  )
}

export const useUpdateDefaultGroupManager = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({
      id,
      directReportsOfWid,
    }: {
      id: number
      directReportsOfWid: number | null
    }) => updateApprovalGroupDefaultGroupManager(id, directReportsOfWid),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(adminApprovalGroupsKeys.all)
        void queryClient.invalidateQueries(approvalGroupsKeys.all)
      },
    },
  )
}

export const useToggleAutoApproval = () => {
  const queryClient = useQueryClient()

  return useMutation((id: number) => toggleApprovalGroupAutoApproval(id), {
    onSuccess: () => {
      void queryClient.invalidateQueries(adminApprovalGroupsKeys.all)
    },
  })
}
